// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-master-panel {
  background-color: rgba( 248, 248, 248 ,  1 );
  background-color: rgba( var(--palette-neutral-2,248, 248, 248) ,  1 );
  border-right: 1px solid rgba(0, 0, 0, 0.08);
  border-right: 1px solid var(--palette-black-alpha-8,rgba(0, 0, 0, 0.08));
}
@media screen and (max-width: 1023px) {
  .bolt-master-panel:not(.show-on-small-screens) {
    display: none !important;
  }
}
@media screen and (min-width: 1920px) {
  .bolt-master-panel {
    width: 384px;
  }
}
@media screen and (max-width: 1919px) {
  .bolt-master-panel {
    width: 320px;
  }
}
@media screen and (max-width: 1365px) {
  .bolt-master-panel {
    width: 280px;
  }
}
.bolt-master-panel.full-screen {
  width: 100%;
}

.bolt-master-panel-header {
  padding-top: 8px;
  padding-bottom: 24px;
  transition: padding 0.2s ease 0s;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: inherit;
}
.bolt-master-panel-header.hide {
  visibility: hidden;
  position: absolute;
  top: 0;
}
.bolt-master-panel-header.has-search {
  padding-bottom: 8px;
}
.bolt-master-panel-header.content-scrolled {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid var(--palette-black-alpha-8,rgba(0, 0, 0, 0.08));
  padding-bottom: 8px;
}
.bolt-master-panel-header.content-scrolled .bolt-master-panel-header-title {
  font-size: 0.9375rem;
}
.bolt-master-panel-header.content-scrolled .bolt-master-panel-header-secondary {
  display: none;
}
.bolt-master-panel-header.content-scrolled .bolt-master-panel-standard-header {
  padding-top: 0px;
}

.bolt-master-panel-standard-header {
  transition: padding 0.2s ease 0s;
}

.bolt-master-panel-header-title {
  transition: font-size 0.2s ease 0s;
}

.bolt-master-panel-header-title,
.bolt-master-panel-subtitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bolt-master-panel-search {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid var(--palette-black-alpha-8,rgba(0, 0, 0, 0.08));
  padding: 9px 21px;
}

.bolt-master-panel-content .bolt-list-row.selected {
  background-color: rgba( 234, 234, 234 ,  1 );
  background-color: rgba( var(--palette-neutral-8,234, 234, 234) ,  1 );
}
@media (forced-colors: active) {
  .bolt-master-panel-content .bolt-list-row.selected {
    background-color: highlight;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-master-panel-content .bolt-list-row.selected .bolt-list-cell:first-child {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-master-panel-content .bolt-list-row.selected .bolt-list-cell:first-child {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}

/*# sourceMappingURL=SingleLayerMasterPanel.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/SingleLayerMasterPanel/SingleLayerMasterPanel.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/SingleLayerMasterPanel/SingleLayerMasterPanel.css"],"names":[],"mappings":"AAGA;EACI,4CCwFQ;EDvFR,qEAAA;EEFF,2CAA2C;EDmWzC,wEAAA;ACjWJ;AACA;EACE;IACE,wBAAwB;EDgXxB;AC9WJ;AACA;EACE;IACE,YAAY;EDqWZ;ACnWJ;AACA;EACE;IACE,YAAY;ED0VZ;ACxVJ;AACA;EACE;IACE,YAAY;EFEZ;AEAJ;AACA;EACE,WAAW;AFGb;;AEAA;EFGI,gBAAA;EAGA,oBAAA;EACA,gCAAA;EACA,gBAAA;EAEA,MAAA;EEJF,UAAU;EFMR,yBAAA;AEJJ;AACA;EFMQ,kBAAA;EEJN,kBAAkB;EFOhB,MAAA;AELJ;AACA;EFQI,mBAAA;AENJ;AACA;EACE,4CAA4C;EFQtC,yEAAA;EACI,mBCoNC;AC1Nb;AFSQ;EACI,oBAAA;AEPZ;AFUQ;EACI,aAAA;AERZ;AACA;EFYA,gBAAA;AEVA;;AAEA;EFYA,gCAAA;AEVA;;AAEA;EFYA,kCAAA;AAAA;;AERA;;EAEE,gBAAgB;EAChB,uBAAuB;EFYzB,mBAAA;AEVA;;AAEA;EACE,4CAA4C;EFa1C,yEAAA;EACI,iBAAA;AEXR;;AAEA;EACE,4CFWU;EEVV,qEAAqE;AACvE;AFaY;EACI;IEXZ,2BAA2B;EFUnB;AERZ;AACA;EACE,sCAAsC;EACtC,gEAAgE;AAClE;AACA;EACE,sCAAsC;EACtC,gEAAgE;AAClE;;AAEA,qDAAqD","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
